// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.actual-amount[data-v-0d361418] { color: #f56c6c; font-weight: 600;\n}\n.reveal-btn[data-v-0d361418] { margin-left: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
